// source: pbtypes/gen/scan_planner/structure_column_inspection_scan_request.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_eigen_lcm_Vector2d_pb = require('../../../pbtypes/gen/eigen_lcm/Vector2d_pb.js');
goog.object.extend(proto, pbtypes_gen_eigen_lcm_Vector2d_pb);
var pbtypes_gen_structure_structure_pb = require('../../../pbtypes/gen/structure/structure_pb.js');
goog.object.extend(proto, pbtypes_gen_structure_structure_pb);
goog.exportSymbol('proto.scan_planner.StructureColumnInspectionScanRequest', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.scan_planner.StructureColumnInspectionScanRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.scan_planner.StructureColumnInspectionScanRequest.repeatedFields_, null);
};
goog.inherits(proto.scan_planner.StructureColumnInspectionScanRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.scan_planner.StructureColumnInspectionScanRequest.displayName = 'proto.scan_planner.StructureColumnInspectionScanRequest';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.scan_planner.StructureColumnInspectionScanRequest.repeatedFields_ = [1,5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.scan_planner.StructureColumnInspectionScanRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.scan_planner.StructureColumnInspectionScanRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.scan_planner.StructureColumnInspectionScanRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scan_planner.StructureColumnInspectionScanRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
structuresList: jspb.Message.toObjectList(msg.getStructuresList(),
    pbtypes_gen_structure_structure_pb.Structure.toObject, includeInstance),
standoffDistance: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
gimbalPitchesList: (f = jspb.Message.getRepeatedFloatingPointField(msg, 5)) == null ? undefined : f,
columnPositionXy: (f = msg.getColumnPositionXy()) && pbtypes_gen_eigen_lcm_Vector2d_pb.Vector2dPb.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.scan_planner.StructureColumnInspectionScanRequest}
 */
proto.scan_planner.StructureColumnInspectionScanRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.scan_planner.StructureColumnInspectionScanRequest;
  return proto.scan_planner.StructureColumnInspectionScanRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.scan_planner.StructureColumnInspectionScanRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.scan_planner.StructureColumnInspectionScanRequest}
 */
proto.scan_planner.StructureColumnInspectionScanRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new pbtypes_gen_structure_structure_pb.Structure;
      reader.readMessage(value,pbtypes_gen_structure_structure_pb.Structure.deserializeBinaryFromReader);
      msg.addStructures(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setStandoffDistance(value);
      break;
    case 5:
      reader.readPackableFloatInto(msg.getGimbalPitchesList());
      break;
    case 7:
      var value = new pbtypes_gen_eigen_lcm_Vector2d_pb.Vector2dPb;
      reader.readMessage(value,pbtypes_gen_eigen_lcm_Vector2d_pb.Vector2dPb.deserializeBinaryFromReader);
      msg.setColumnPositionXy(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.scan_planner.StructureColumnInspectionScanRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.scan_planner.StructureColumnInspectionScanRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.scan_planner.StructureColumnInspectionScanRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scan_planner.StructureColumnInspectionScanRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStructuresList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      pbtypes_gen_structure_structure_pb.Structure.serializeBinaryToWriter
    );
  }
  f = message.getStandoffDistance();
  if (f !== 0.0) {
    writer.writeFloat(
      3,
      f
    );
  }
  f = message.getGimbalPitchesList();
  if (f.length > 0) {
    writer.writePackedFloat(
      5,
      f
    );
  }
  f = message.getColumnPositionXy();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      pbtypes_gen_eigen_lcm_Vector2d_pb.Vector2dPb.serializeBinaryToWriter
    );
  }
};


/**
 * repeated structure.Structure structures = 1;
 * @return {!Array<!proto.structure.Structure>}
 */
proto.scan_planner.StructureColumnInspectionScanRequest.prototype.getStructuresList = function() {
  return /** @type{!Array<!proto.structure.Structure>} */ (
    jspb.Message.getRepeatedWrapperField(this, pbtypes_gen_structure_structure_pb.Structure, 1));
};


/**
 * @param {!Array<!proto.structure.Structure>} value
 * @return {!proto.scan_planner.StructureColumnInspectionScanRequest} returns this
*/
proto.scan_planner.StructureColumnInspectionScanRequest.prototype.setStructuresList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.structure.Structure=} opt_value
 * @param {number=} opt_index
 * @return {!proto.structure.Structure}
 */
proto.scan_planner.StructureColumnInspectionScanRequest.prototype.addStructures = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.structure.Structure, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.scan_planner.StructureColumnInspectionScanRequest} returns this
 */
proto.scan_planner.StructureColumnInspectionScanRequest.prototype.clearStructuresList = function() {
  return this.setStructuresList([]);
};


/**
 * optional float standoff_distance = 3;
 * @return {number}
 */
proto.scan_planner.StructureColumnInspectionScanRequest.prototype.getStandoffDistance = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.scan_planner.StructureColumnInspectionScanRequest} returns this
 */
proto.scan_planner.StructureColumnInspectionScanRequest.prototype.setStandoffDistance = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * repeated float gimbal_pitches = 5;
 * @return {!Array<number>}
 */
proto.scan_planner.StructureColumnInspectionScanRequest.prototype.getGimbalPitchesList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedFloatingPointField(this, 5));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.scan_planner.StructureColumnInspectionScanRequest} returns this
 */
proto.scan_planner.StructureColumnInspectionScanRequest.prototype.setGimbalPitchesList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.scan_planner.StructureColumnInspectionScanRequest} returns this
 */
proto.scan_planner.StructureColumnInspectionScanRequest.prototype.addGimbalPitches = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.scan_planner.StructureColumnInspectionScanRequest} returns this
 */
proto.scan_planner.StructureColumnInspectionScanRequest.prototype.clearGimbalPitchesList = function() {
  return this.setGimbalPitchesList([]);
};


/**
 * optional eigen_lcm.Vector2dPb column_position_xy = 7;
 * @return {?proto.eigen_lcm.Vector2dPb}
 */
proto.scan_planner.StructureColumnInspectionScanRequest.prototype.getColumnPositionXy = function() {
  return /** @type{?proto.eigen_lcm.Vector2dPb} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_eigen_lcm_Vector2d_pb.Vector2dPb, 7));
};


/**
 * @param {?proto.eigen_lcm.Vector2dPb|undefined} value
 * @return {!proto.scan_planner.StructureColumnInspectionScanRequest} returns this
*/
proto.scan_planner.StructureColumnInspectionScanRequest.prototype.setColumnPositionXy = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.scan_planner.StructureColumnInspectionScanRequest} returns this
 */
proto.scan_planner.StructureColumnInspectionScanRequest.prototype.clearColumnPositionXy = function() {
  return this.setColumnPositionXy(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.scan_planner.StructureColumnInspectionScanRequest.prototype.hasColumnPositionXy = function() {
  return jspb.Message.getField(this, 7) != null;
};


goog.object.extend(exports, proto.scan_planner);
